/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DATEVConfig } from '../models/DATEVConfig';
import type { DATEVExportRun } from '../models/DATEVExportRun';
import type { PaginatedDATEVConfigList } from '../models/PaginatedDATEVConfigList';
import type { PaginatedDATEVExportRunList } from '../models/PaginatedDATEVExportRunList';
import type { PatchedDATEVConfig } from '../models/PatchedDATEVConfig';
import type { PatchedDATEVConfigVersion } from '../models/PatchedDATEVConfigVersion';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DatevEndpoint {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns PaginatedDATEVConfigList
   * @throws ApiError
   */
  public datevConfigsList({
    company,
    companyDrivingSchoolId,
    limit,
    offset,
    ordering,
  }: {
    company?: string,
    companyDrivingSchoolId?: string,
    /**
     * Number of results to return per page.
     */
    limit?: number,
    /**
     * The initial index from which to return the results.
     */
    offset?: number,
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string,
  }): CancelablePromise<PaginatedDATEVConfigList> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/datev-configs/',
      query: {
        'company': company,
        'company__driving_school_id': companyDrivingSchoolId,
        'limit': limit,
        'offset': offset,
        'ordering': ordering,
      },
    });
  }

  /**
   * @returns DATEVConfig
   * @throws ApiError
   */
  public datevConfigsRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this datev config.
     */
    id: string,
  }): CancelablePromise<DATEVConfig> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/datev-configs/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns DATEVConfig
   * @throws ApiError
   */
  public datevConfigsUpdate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this datev config.
     */
    id: string,
    requestBody: DATEVConfig,
  }): CancelablePromise<DATEVConfig> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/datev-configs/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns DATEVConfig
   * @throws ApiError
   */
  public datevConfigsPartialUpdate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this datev config.
     */
    id: string,
    requestBody?: PatchedDATEVConfig,
  }): CancelablePromise<DATEVConfig> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/datev-configs/{id}/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns DATEVConfig
   * @throws ApiError
   */
  public datevConfigsVersionCreate({
    id,
    requestBody,
  }: {
    /**
     * A UUID string identifying this datev config.
     */
    id: string,
    requestBody?: PatchedDATEVConfigVersion,
  }): CancelablePromise<DATEVConfig> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/datev-configs/{id}/version/',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * @returns PaginatedDATEVExportRunList
   * @throws ApiError
   */
  public datevExportRunsList({
    company,
    companyDrivingSchoolId,
    customerDownloaded,
    isFaulty,
    limit,
    mode,
    offset,
    ordering,
    status,
  }: {
    company?: string,
    companyDrivingSchoolId?: string,
    customerDownloaded?: boolean,
    isFaulty?: boolean,
    /**
     * Number of results to return per page.
     */
    limit?: number,
    /**
     * * `MONTHLY` - Monatsabschluss
     * * `PAYMENTS` - Zahlungen und Gebühren
     * * `PAYOUT` - Auszahlung
     * * `OPENING` - Migriertes Anfangsguthaben
     * * `ALL` - Belege und Auszahlungszuordnung
     * * `CORRECTION` - Korrektur
     */
    mode?: 'ALL' | 'CORRECTION' | 'MONTHLY' | 'OPENING' | 'PAYMENTS' | 'PAYOUT',
    /**
     * The initial index from which to return the results.
     */
    offset?: number,
    /**
     * Which field to use when ordering the results.
     */
    ordering?: string,
    /**
     * * `RUNNING` - In Erstellung
     * * `SUCCEEDED` - Erstellt
     * * `FAILED` - Fehlgeschlagen
     */
    status?: 'FAILED' | 'RUNNING' | 'SUCCEEDED',
  }): CancelablePromise<PaginatedDATEVExportRunList> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/datev-export-runs/',
      query: {
        'company': company,
        'company__driving_school_id': companyDrivingSchoolId,
        'customer_downloaded': customerDownloaded,
        'is_faulty': isFaulty,
        'limit': limit,
        'mode': mode,
        'offset': offset,
        'ordering': ordering,
        'status': status,
      },
    });
  }

  /**
   * @returns DATEVExportRun
   * @throws ApiError
   */
  public datevExportRunsRetrieve({
    id,
  }: {
    /**
     * A UUID string identifying this datev export run.
     */
    id: string,
  }): CancelablePromise<DATEVExportRun> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/datev-export-runs/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @returns binary
   * @throws ApiError
   */
  public datevExportRunsDownloadCreate({
    id,
  }: {
    /**
     * A UUID string identifying this datev export run.
     */
    id: string,
  }): CancelablePromise<Blob> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/datev-export-runs/{id}/download/',
      path: {
        'id': id,
      },
    });
  }

}
